import React from 'react'
import PageTitle from '../../_Components/Common/PageTitle/PageTitle'
import {
  usePeriodData,
  PeriodControls,
  GrowthValue,
  isPlaceholder,
  num,
  percent,
  Wrapper,
  Message,
  TableBox,
  Table,
  Th,
  Td,
  TotalFoot,
  Name,
  Note,
  Muted,
  Footnote,
} from './dataShared'

/*
 * 스티팝 채팅방에서 나간 코인을 대화 모델별로 본다.
 * 집계는 adminapi 의 /v2/admin-data/message-coin 이 전부 담당하고 여기서는 표시만 한다.
 * 주소가 상대 경로인 것은 어드민 서버가 adminapi 로 프록시하기 때문이다 (구글 토큰 인증).
 */
const URL = '/new/webAdmin/v2/admin-data/message-coin'

const StipopMessageCoinData = () => {
  const state = usePeriodData({
    url: URL,
    // 토큰은 로그인 시점에 채워지므로 요청할 때 읽는다.
    headers: () => ({ token: window.sessionStorage.getItem('token') }),
    unwrap: data => data,
  })
  const { body, loading, error, prevLabel } = state
  const list = body.list || []
  const total = body.total || null

  const renderRow = (row, isTotal) => (
    <tr key={row.model}>
      <Td align="left">
        <Name faded={!isTotal && isPlaceholder(row.model)}>{row.model}</Name>
        {row.region !== '-' && <Note>{row.region}</Note>}
      </Td>
      <Td>
        <strong>{num(row.net)}</strong>
        {!isTotal && <Note>{row.netShare}%</Note>}
      </Td>
      <Td>{num(row.spend)}</Td>
      <Td>
        {num(row.refund)}
        {/* 생성 실패가 늘면 환불률이 먼저 올라간다 */}
        <Note>{percent(row.refundRate)}</Note>
      </Td>
      <Td>{num(row.users)}</Td>
      <Td>{num(row.count)}</Td>
      <Td>{num(row.avgPerUser)}</Td>
      <Td>{num(row.avgSpendPerUser)}</Td>
      <Td>
        {row.avgUnit}코인
        {/* 텍스트 1코인이 기본이고 이미지 첨부·무드샷 등이 섞이면 올라간다 */}
        {!!(row.unitMix || []).length && (
          <Note>
            {row.unitMix
              .slice(0, 4)
              .map(mix => `${mix.unit}코인 ${num(mix.count)}`)
              .join(' · ')}
          </Note>
        )}
      </Td>
      <Td>{num(row.maxPerUser)}</Td>
      <Td>{percent(row.topUserShare)}</Td>
      <Td>
        <GrowthValue value={row.growth && row.growth.net} />
      </Td>
    </tr>
  )

  return (
    <Wrapper>
      <PageTitle
        mainTitle={'Stipop Chat Coin Data'}
        v1Link={''}
        navNames={['Data Analytics', 'Stipop Chat Coin Data']}
      />

      <PeriodControls
        state={state}
        summary={
          !!total && (
            <span>
              메시지 {num(total.count)}건 · 유저 {num(total.users)}명 · 순소비{' '}
              {num(total.net)}코인
            </span>
          )
        }
      />

      {error && <Message>{error}</Message>}
      {loading && !error && <Message>불러오는 중…</Message>}

      {!loading && !error && (
        <TableBox>
          <Table>
            <thead>
              <tr>
                <Th align="left">대화 모델</Th>
                <Th title="차감 − 환불">순소비 코인</Th>
                <Th>차감</Th>
                <Th title="생성 실패·오류로 되돌려준 코인">환불</Th>
                <Th>유저 수</Th>
                <Th>차감 건수</Th>
                <Th>인당 건수</Th>
                <Th>인당 코인</Th>
                <Th title="차감 1건당 평균 코인">평균 단가</Th>
                <Th>최다 유저</Th>
                <Th title="코인을 가장 많이 쓴 상위 10% 유저의 순소비 비중">상위 10% 점유</Th>
                <Th title={prevLabel && `직전 기간 ${prevLabel}`}>직전 기간 대비</Th>
              </tr>
            </thead>
            <tbody>
              {list.map(row => renderRow(row, false))}
              {!list.length && (
                <tr>
                  <Td colSpan={12}>
                    <Muted>이 기간에 차감된 채팅 코인이 없습니다.</Muted>
                  </Td>
                </tr>
              )}
            </tbody>
            {!!list.length && total && <TotalFoot>{renderRow(total, true)}</TotalFoot>}
          </Table>
        </TableBox>
      )}

      <Footnote>
        채팅방에서 코인이 오간 기록을 대화 상대 캐릭터의 모델로 묶은 것입니다. FANZA 와
        달리 기능별로는 가를 수 없습니다 — 텍스트 발신, 이미지 첨부, 무드샷, 이미지 편집이
        모두 같은 코드로 기록되고 금액으로도 갈리지 않기 때문입니다(장기기억 텍스트 2코인 =
        이미지 첨부 2코인 = 편집 2코인). 대신 「평균 단가」 아래의 단가 분포로 구성을 짐작할
        수 있습니다. 1코인이 순수 텍스트 기본값이고, 3코인 건수는 대체로 무드샷 요청입니다.
        기능별 내역은 Stipop Image/Video Data 화면에서 봅니다. 「환불」은 생성 실패로
        되돌려준 코인이고 「순소비」가 실제로 나간 금액입니다. 유저 수는 모델별로 따로 세기
        때문에 여러 모델을 쓴 유저는 각 줄에 모두 잡힙니다 — 모델 행을 더해도 합계 유저 수와
        같지 않습니다(코인과 건수는 일치합니다). 「상위 10% 점유」는 코인을 가장 많이 쓴 상위
        10% 유저가 차지하는 순소비 비중으로, 매출이 소수에게 몰려 있는 정도를 봅니다.
        「직전 기간 대비」는 바로 앞의 같은 길이 기간{prevLabel ? `(${prevLabel})` : ''}과
        비교한 순소비 증감입니다. 「(삭제된 대화)」「(삭제된 캐릭터)」는 차감 기록만 남고
        대화방이나 캐릭터가 지워져 모델을 되짚을 수 없는 건입니다.
      </Footnote>
    </Wrapper>
  )
}

export default StipopMessageCoinData
